import { Scale, ShieldCheck, MapPinned, Compass, FileText, Landmark } from "lucide-react";

export const SERVICES = [
  {
    slug: "civil-legal-services",
    no: "01",
    title: "Civil & Legal Services",
    short: "Expert legal guidance and representation across civil matters, agreements and disputes.",
    body: "Expert legal guidance and representation for a wide range of civil matters, drafting of agreements, legal documentation, dispute resolution, and advisory services tailored to protect your interests.",
    scope: ["Guidance & representation in civil matters", "Drafting of agreements", "Legal documentation", "Dispute resolution", "Tailored advisory services"],
    icon: Scale,
    image: "/images/signing.jpg",
  },
  {
    slug: "property-verification",
    no: "02",
    title: "Property Verification",
    short: "Rigorous checks on titles, ownership history, encumbrances and physical status.",
    body: "Rigorous and detailed verification of property titles, ownership history, encumbrances, and physical status to ensure clean and marketable title acquisitions.",
    scope: ["Property title verification", "Ownership history review", "Encumbrance checks", "Physical status inspection", "Clean & marketable title assurance"],
    icon: ShieldCheck,
    image: "/images/keys.jpg",
  },
  {
    slug: "land-verification",
    no: "03",
    title: "Land Verification",
    short: "Land status, boundary surveys, mutation records and clearance assessments.",
    body: "Comprehensive land status checks, boundary surveys verification, mutation records inspection, and clearance assessments to safeguard your land investments from future disputes.",
    scope: ["Land status checks", "Boundary survey verification", "Mutation records inspection", "Clearance assessments", "Protection from future disputes"],
    icon: MapPinned,
    image: "/images/survey.jpg",
  },
  {
    slug: "finding-unknown-properties",
    no: "04",
    title: "Finding Unknown Properties",
    short: "Tracing untraced or forgotten ancestral, familial and unclaimed real estate.",
    body: "Specialized investigative services to trace, locate, and verify untraced or forgotten ancestral, familial, or unclaimed real estate assets and land parcels.",
    scope: ["Tracing untraced properties", "Locating ancestral & familial assets", "Verifying unclaimed land parcels", "Investigative record research"],
    icon: Compass,
    image: "/images/hero.jpg",
  },
  {
    slug: "legal-opinion",
    no: "05",
    title: "Legal Opinion",
    short: "Authoritative opinions on titles, conversions, succession and transactions.",
    body: "Authoritative and well-researched legal opinions on property titles, land conversions, succession matters, and transactional viability to empower secure decision-making.",
    scope: ["Opinions on property titles", "Land conversion matters", "Succession matters", "Transactional viability"],
    icon: FileText,
    image: "/images/statue.jpg",
  },
  {
    slug: "bank-loans",
    no: "06",
    title: "Bank Loans",
    short: "End-to-end facilitation for property-backed loans and mortgage financing.",
    body: "End-to-end financial facilitation and advisory for property-backed loans, mortgage financing, and credit structuring through leading banking and financial institutions.",
    scope: ["Property-backed loans", "Mortgage financing", "Credit structuring", "Coordination with banks & financial institutions"],
    icon: Landmark,
    image: "/images/office.jpg",
  },
];

export const CONTACT = {
  phone: "+91 9992333357",
  tel: "+919992333357",
  email: "srinivas@myassociates.org.in",
  location: "Guntur, Andhra Pradesh",
  address: "9-13-875/A, 5th Ward, Shyamalanagar, Guntur – 522006, Andhra Pradesh",
  mapQuery: "Shyamala Nagar, Guntur, Andhra Pradesh 522006",
  whatsapp: "https://wa.me/919992333357?text=Hello%20Ridhanya%20Associates%2C%20I%20would%20like%20to%20enquire%20about%20your%20services.",
};

export const WHY = [
  { title: "Expertise & Experience", text: "Deep domain knowledge in property laws, civil procedures, and land documentation." },
  { title: "Client-Centric Approach", text: "Transparent communication, personalized advisory, and prompt turnaround times." },
  { title: "Comprehensive Solutions", text: "A single window for all legal, verification, and financial needs related to real estate." },
];
